<template>
    <div>
        <HeaderSection icon="fas fa-building" title="Administración de Oficinas">
            <template slot="buttons">
                <el-button
                        size="medium"
                        type="danger"
                        icon="el-icon-arrow-left"
                        @click="$router.push('/administracion')">
                    Regresar
                </el-button>
                <el-button
                        size="medium"
                        type="success"
                        icon="fas fa-user-plus"
                        @click="$router.push('/administracion/oficinas/crear')">
                    Agregar oficina
                </el-button>
            </template>
        </HeaderSection>
       
        <el-row>
            <el-col :span="18">
                <el-pagination
                        style="display: inline-block;margin-left: -10px;"
                        @size-change="handleSizeChange"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="parseInt(perPage)"
                        layout="sizes">
                </el-pagination>
            </el-col>
            <el-col :span="6">
                <el-input
                        v-model="search"
                        clearable
                        placeholder="Filtrar"
                        @clear="handleCurrentChange(1)"
                        @keyup.enter.native="handleCurrentChange(1)">
                    <el-button slot="append" :icon="icon" @click="handleCurrentChange(1)"></el-button>
                </el-input>
            </el-col>
        </el-row>
        <br>
        <el-table
                :data="offices"
                :default-sort = "{prop: 'type', order: 'ascending'}"
                border
                stripe
                size="small">
            <el-table-column
                    prop="type"
                    label="Tipo"
                    sortable
                    width="125">
            </el-table-column>
            <el-table-column
                    prop="location"
                    label="Ubicación"
                    sortable
                    >
            </el-table-column>
            <el-table-column
                    prop="city"
                    label="Ciudad"
                    sortable
                    >
            </el-table-column>
            <el-table-column
                    prop="country"
                    label="País"
                    sortable
                    >
            </el-table-column>
            
            <el-table-column
                label="Acciones"
                align="center" >
                <template slot-scope="scope">
                    <el-button-group width="350">

                        <el-tooltip class="item" effect="dark" content="Editar" placement="top">
                            <el-button
                                    type="info"
                                    icon="fas fa-edit"
                                    size="small"
                                    @click="editUser(scope.row.crypt_id)">
                            </el-button>
                        </el-tooltip>

                        <el-tooltip class="item" effect="dark" content="Eliminar" placement="top">
                            <el-button
                                    type="danger"
                                    size="small"
                                    icon="fas fa-trash"
                                    @click="deleteUser(scope.$index,scope.row)">
                            </el-button>
                        </el-tooltip>
                    </el-button-group>
                </template>
                    
            </el-table-column>
        </el-table>
        <br>
         <el-pagination
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                layout="total, ->, prev, pager, next"
                :total="total"
                :page-size="parseInt(perPage)">
        </el-pagination>
    </div>
</template>

<script>
    import HeaderSection from '../../../partials/HeaderSection';

    export default {
     
        components: {
            HeaderSection,
          
        },
        

        data() {
            return {
                offices: [],
                search: '',
                icon: 'el-icon-search',
                currentPage: 1,
                perPage: 10,
                total: 0,
                sortable: {
                    sort: 'ASC',
                    column: 'type'
                },
            }
        },

        created() {
            this.getOffices()
        },

        

        methods: {
            showLoading() {
                this.$store.dispatch(
                    'loading/spinner',
                    {msg: 'Cargando Datos...', status: true},
                    {root: true}
                );
            },
            hideLoading() {
                this.$store.dispatch('loading/spinner', {}, {root: true});
            },

            getOffices(page = 1) {
                let _this = this;
                let params = {
                    page: page,
                    search: this.search,
                    perPage: this.perPage,
                    column: this.sortable.column,
                    sort: this.sortable.sort,
                };

                _this.icon = 'fa fa fa-spinner fa-spin';
                _this.showLoading();

                axios.get('/api/offices', {params}).then(response => {
                    let offices = response.data.offices;

                    _this.offices       = offices.data;
                    _this.total       = offices.total;
                    _this.currentPage = offices.current_page;
                    _this.perPage     = offices.per_page;

                    _this.hideLoading();
                    _this.icon = 'el-icon-search';
                }).catch(error => {
                    _this.hideLoading();
                    _this.icon = 'el-icon-search';

                    _this.$notify.error({
                        title: 'Error',
                        message: 'No se pudo completar la acción.'
                    });
                });
            },


            handleCurrentChange(page) {
                this.getOffices(page);
            },
            handleSizeChange(perPage) {
                this.perPage = perPage;
                this.getOffices();
            },
            handleSort(sort) {

                if (!sort.prop) {
                    sort.order = 'ascending';
                    sort.prop = 'name';
                }

                this.sortable.sort = sort.order === 'ascending' ? 'ASC' : 'DESC';
                this.sortable.column = sort.prop ? sort.prop : 'name';
                this.getOffices(this.currentPage);
            },

            editUser(id) {
                this.$router.push('/administracion/oficinas/editar/' + id);
            },
            deleteUser(index, row) {

                this.$confirm('¿Desea eliminar este registro?', '', {
                    confirmButtonText: 'Si',
                    cancelButtonText: 'Cancelar',
                    type: 'warning'
                }).then(() => {

                    var url = '/api/offices/' + row.crypt_id;
                    axios.delete(url).then(response => {
                        this.$notify({
                            title: 'Éxito',
                            message: 'Se eliminó correctamente',
                            type: 'success'
                        });
                        this.getOffices();
                    })
                }).catch(() => {
                    this.$notify.info({
                        title: 'Cancelado',
                        message: 'Registro no eliminado',
                    });
                });
            },
        }
        
    }
</script>

<style>
</style>
